import KycFooter from './kyc-footer';

export default KycFooter;
